import { AUTH_REFRESH_PATH, isSessionExemptPath } from '@/config/auth-routes'
import { emitSessionExpired } from '@/features/auth/model/session-events'
import { buildUrl, type SearchParams } from '@/lib/http/api-url'

let inFlight: Promise<boolean> | null = null
let epoch = 0

export function refreshSession(): Promise<boolean> {
  return (inFlight ??= fetch(buildUrl(AUTH_REFRESH_PATH), {
    method: 'POST',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  })
    .then((response) => {
      if (response.ok) epoch += 1
      // Only the server refusing the refresh means the session is over. A
      // rejected fetch means we could not ask, which is a dead network and not
      // grounds for signing anybody out.
      else emitSessionExpired()
      return response.ok
    })
    .catch(() => false)
    .finally(() => {
      inFlight = null
    }))
}

export async function sessionFetch(
  path: string,
  init: RequestInit = {},
  searchParams?: SearchParams,
): Promise<Response> {
  const url = buildUrl(path, searchParams)
  const send = () => fetch(url, { ...init, credentials: 'include' })

  const epochBefore = epoch
  const response = await send()

  if (response.status !== 401 || isSessionExemptPath(path)) return response

  const recovered = epoch !== epochBefore || (await refreshSession())

  if (!recovered) return response

  return send()
}
